import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { StaticQuery } from 'gatsby';
import ListGroup from '../components/ListGroup';

var ApiNavigation = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ApiNavigation, _React$Component);

  function ApiNavigation() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ApiNavigation.prototype;

  _proto.filterItems = function filterItems(type) {
    return this.props.items.filter(function (item) {
      return item.node.parentPid === type;
    });
  };

  _proto.render = function render() {
    var selectedId = this.props.selectedId;
    return /*#__PURE__*/React.createElement("div", {
      className: "nav"
    }, /*#__PURE__*/React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'MODULES',
      items: this.filterItems('module')
    }), /*#__PURE__*/React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'EXTERNALS',
      items: this.filterItems('external')
    }), /*#__PURE__*/React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'CLASSES',
      items: this.filterItems('class')
    }), /*#__PURE__*/React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'NAMESPACES',
      items: this.filterItems('namespace')
    }), /*#__PURE__*/React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'MIXINS',
      items: this.filterItems('mixin')
    }), /*#__PURE__*/React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'TYPEDEF',
      items: this.filterItems('typedef')
    }), /*#__PURE__*/React.createElement(ListGroup, {
      selectedId: selectedId,
      title: 'GLOBAL',
      items: this.filterItems('global')
    }));
  };

  return ApiNavigation;
}(React.Component);

var NavigationWrapper = function NavigationWrapper(props) {
  return /*#__PURE__*/React.createElement(StaticQuery, {
    query: "1897965698",
    render: function render(data) {
      return /*#__PURE__*/React.createElement(ApiNavigation, Object.assign({
        items: data.allNavigationJson.edges
      }, props));
    }
  });
};

export default NavigationWrapper;